import React, { useEffect, useState } from 'react';
import { Row, Col, Card, FloatingLabel, Form, Button } from 'react-bootstrap';


const FinalizarJogo = ({ jogo, finalizarJogo, voltar }) => {
    //Desenhar 3 selects para escolher a equipa do melhor jogador, o melhor jogador e a melhor claque.
    //No final, um botão para finalizar o jogo.
    const [{ claque_selected }, setData] = useState({
        claque_selected: 'none',

    });

    const [finalizarDisponivel, setFinalizarDisponivel] = useState(false);

    useEffect(() => {
        checkFinalizarDisponivel();
    }, [claque_selected]);

    const checkFinalizarDisponivel = () => {
        if ( claque_selected !== 'none') {
            setFinalizarDisponivel(true);
        } else {
            setFinalizarDisponivel(false);
        }
    }

    function handleClaqueChange(event) {
        setData(data => ({ ...data, claque_selected: event.target.value }));
    }

    const claques_data = jogo ? [<option key="claques-0" value="none"></option>,
    <option key={`claques-${jogo.equipacasaid}`} value={jogo.equipacasaid}>
        {jogo.equipacasa}
    </option>,
    <option key={`claques-${jogo.equipaforaid}`} value={jogo.equipaforaid}>
        {jogo.equipafora}
    </option>,
    <option key={`claques-00`} value='0'>
        Nenhuma se destacou
    </option>
    ] : null;

    return (
        <>
            <Card>
                <Card.Header>
                    <Card.Title>Melhor Claque</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Row className='mb-3'>
                        <Col>
                            <FloatingLabel controlId="floatingSelect" label="Claque">
                                <Form.Select aria-label="Claque"
                                    onChange={handleClaqueChange}
                                    value={claque_selected}>
                                    {claques_data}
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <br />
            <Row className="mb-3">
                <Col className="d-flex justify-content-center align-items-center">
                    <Button variant="secondary" size="lg" onClick={voltar}>
                        Voltar
                    </Button>
                </Col>
                {finalizarDisponivel ?
                    (<Col className="d-flex justify-content-center align-items-center">
                        <Button variant="danger" size="lg" onClick={() => finalizarJogo({  melhorclaque: claque_selected })}>
                            Confirmar Finalizar
                        </Button>
                    </Col>) : null}
            </Row>
        </>
    );
}

export default FinalizarJogo;